import React, { useCallback } from 'react';
import cx from 'classnames';

import { DateService, NotificationManager } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

const DOCUMENT_STATUSES_MESSAGES = {
  DECLINED: 'declined',
  UPLOADED: 'uploaded',
  VERIFIED: 'verified',
};

const DOCUMENT_STATUSES_ICONS = {
  DECLINED: 'warning',
  VERIFIED: 'done',
};

const statusIcon = verificationStatus => {
  if (verificationStatus === 'UPLOADED') return null;

  return (
    <Icon
      className={`icon-${DOCUMENT_STATUSES_ICONS[verificationStatus]}`}
      name={DOCUMENT_STATUSES_ICONS[verificationStatus]}
    />
  );
};

export default function UploadDocumentItem({ document }) {
  const { declineVerificationReason, documentType, documentUploadTime, verificationStatus } =
    document;
  const documentUploadDate = DateService.getFormattedDate(documentUploadTime);
  const documentUploadHours = DateService.getFormattedTime(documentUploadTime);

  const isDeclined = verificationStatus === 'DECLINED';
  const isUploaded = verificationStatus === 'UPLOADED';

  const verifyClassName = cx('profile-verify__item', { error: verificationStatus === 'DECLINED' });

  const onViewRejectReasonHandler = useCallback(() => {
    NotificationManager.display({
      data: { shouldNotTranslateMessage: true },
      message: declineVerificationReason,
      status: 'error',
      title: 'verification_document_rejected_title',
      type: 'notification',
    });
  }, [declineVerificationReason]);

  return (
    <div className={verifyClassName}>
      <div className="profile-verify__img">
        <Icon name="image" />
      </div>

      <div className="profile-verify__inner">
        <Label className="profile-verify__type" message={documentType} />
        <div className="profile-verify-date">
          <div className="profile-verify-date__day">{documentUploadDate}</div>
          <div className="profile-verify-date__time">{documentUploadHours}</div>
        </div>

        <div className="profile-verify-status">
          {statusIcon(verificationStatus)}

          <div className="profile-verify-status__text">
            <Label message={DOCUMENT_STATUSES_MESSAGES[verificationStatus]} />
            {isUploaded && (
              <Label
                className="profile-verify-status__description"
                message="verify_uploaded_text"
              />
            )}
          </div>

          {isDeclined && declineVerificationReason && (
            <Label
              className="profile-verify-status__link"
              message="what is the problem?"
              onClick={onViewRejectReasonHandler}
            />
          )}
        </div>
      </div>
    </div>
  );
}
